module.exports = __webpack_public_path__ + "static/media/download.94bee113.svg";